package ir.yusefpasha.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.yusefpasha.models.Section
import ir.yusefpasha.style.NavigationItemStyle
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.Res
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*

@Composable
fun OverFlowMenu(onDismissed: () -> Unit) {

    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()

    var opacity by remember { mutableStateOf(0.percent) }
    var translateX by remember { mutableStateOf((-100).percent) }

    LaunchedEffect(breakpoint) {
        translateX = 0.percent
        opacity = 100.percent
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.vh)
            .position(Position.Fixed)
            .zIndex(2)
            .opacity(opacity)
            .backgroundColor(Color.Companion.argb(a = 0.5F, r = 0.0F, g = 0.0F, b = 0.0F))
            .transition(
                CSSTransition(
                    "opacity",
                    duration = Constants.ANIMATION_DURATION + Constants.ANIMATION_DURATION
                )
            )
    ) {
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .padding(all = 25.px)
                .width(if (breakpoint < Breakpoint.MD) 60.percent else 30.percent)
                .backgroundColor(Colors.White)
                .translateX(tx = translateX)
                .overflow(Overflow.Auto)
                .scrollBehavior(ScrollBehavior.Smooth)
                .transition(
                    CSSTransition(
                        "translate",
                        duration = Constants.ANIMATION_DURATION + Constants.ANIMATION_DURATION
                    )
                )
        ) {
            Row(
                modifier = Modifier.margin(bottom = 50.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaXmark(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .margin(right = 20.px, bottom = 3.px)
                        .onClick {
                            scope.launch {
                                translateX = (-100).percent
                                opacity = 0.percent
                                delay(400)
                                onDismissed()
                            }
                        },
                    size = IconSize.X2
                )
                Image(
                    modifier = Modifier.maxWidth(100.px),
                    src = Res.Image.LOGO
                )
            }
            Section.values().take(6).forEach { section ->
                Link(
                    modifier = NavigationItemStyle.toModifier()
                        .margin(bottom = 10.px)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint < Breakpoint.SM) 16.px else 20.px)
                        .fontWeight(FontWeight.Normal)
                        .textDecorationLine(TextDecorationLine.None)
                        .onClick {
                            scope.launch {
                                translateX = (-100).percent
                                opacity = 0.percent
                                delay(400)
                                onDismissed()
                            }
                        }
                    ,
                    path = section.path,
                    text = section.title,
                    openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                )
            }
        }
    }
}